const SwitchConstants = {
    GLOBAL: "global",
}

export default SwitchConstants;